import { render, staticRenderFns } from "./KlasusLevel3.vue?vue&type=template&id=50cd9908&scoped=true"
import script from "./KlasusLevel3.vue?vue&type=script&lang=js"
export * from "./KlasusLevel3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cd9908",
  null
  
)

export default component.exports